//
// this file is loaded for all pages
//
;(function() {
    var

        //set to true when a popup is open, can't open another
        _popup_open = false,

        //
        // init 
        //
        init = function () {
            setupVersionHistory();
            setupFeedback();
            setupChangePassword();
            setupWhatsNew();
        },

        //
        // What's New popup
        //
        setupWhatsNew = function () {
            $(document).on('click', '#WhatsNew', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/shared/whatsNewPopup',
                        function (html) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'What\'s New?',
                                content: html,
                                css: 'modal-lg popup-whats-new',
                                okButtonText: 'Close',
                                afterOpen: function () {
                                    _popup_open = false;
                                }
                            });
                        }
                    )
                }
            });
        },

        //
        // version history popup
        //
        setupVersionHistory = function () {
            $(document).on('click', '#ProductVersion', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/shared/versionHistoryPopup',
                        function (html) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'Version History',
                                content: html,
                                css: 'modal-lg popup-version-history',
                                okButtonText: 'Close',
                                afterOpen: function () {
                                    _popup_open = false;
                                }
                            });
                        }
                    )
                }
            });
        },

        setupFeedback = function () {
            $(document).on('click', '#Feedback', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/shared/feedbackPopup',
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Support & Feedback',
                                css: 'modal-lg',
                                content: html,
                                okButtonText: 'Submit',

                                afterOpen: function ($popup) {
                                    _popup_open = false;

                                    // hide report/chat option, not shown unless specific feedback type selected
                                    $('#rptSelectDiv').hide();
                                    $('#chatSelectDiv').hide();

                                    setupClientChange($popup);
                                    setupFeedbackTypeChange($popup);
                                },

                                okCallback: function ($popup) {

                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input, select, textarea').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/shared/feedbackSave',
                                        formData,
                                        function (result) {

                                            if (result.isValid) {
                                                //close popup
                                                delta.popup.close($popup);
                                                //show confirmation
                                                delta.popup.open({
                                                    type: 'alert',
                                                    title: 'Feedback Submitted',
                                                    content: "Thank you for your submission!",
                                                    okButtonText: 'Close',
                                                    afterOpen: function () {
                                                        _popup_open = false;
                                                    }
                                                });

                                            } else {
                                                //invalid, update the popup
                                                $popup.find('.modal-body').html(result.html);
                                                delta.popup.enableButtons($popup);
                                                var typeItem = $('#TypeItem').val();
                                                if (typeItem != "ReportsYPTC") {
                                                    $('#rptSelectDiv').hide();
                                                }
                                                if (typeItem != "ChatYPTC") {
                                                    $('#chatSelectDiv').hide();
                                                }
                                                setupClientChange($popup);
                                                setupFeedbackTypeChange($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }

                            });
                        }
                    )
                }

                return false;
            });

        },

        //
        //change report list on client change on feedback modal
        //
        setupClientChange = function ($popup) {
            var client = $($popup).find('#ClientID');
            client.on('change', function () {
                var clientID = $(this).val();
                setupFeedbackDropdowns(clientID);
            });

            return false;
        },

        setupFeedbackDropdowns = function (clientID) {
            var formData = new FormData();
            formData.append("ClientID", clientID);

            delta.ajax.postFormData(
                '/shared/feedbackLists',
                formData,
                function (data) {
                    populateFeedbackDropdowns(data);
                }
            );

            return false;
        },

        populateFeedbackDropdowns = function (data) {
            // clear existing dropdowns, hide chat/report divs
            $("#TypeItem").find('option').not(':first').remove();
            $("#rptSelectDiv").hide();
            $("#ReportID").find('option').not(':first').remove();
            $("#chatSelectDiv").hide();
            $("#ChatID").find('option').not(':first').remove();

            // populate the dropdowns
            data.typeList.forEach(function (type) {
                $('#TypeItem').append($("<option></option>").attr("value", type.value).text(type.text));
            });

            data.reportList.forEach(function (report) {
                $('#ReportID').append($("<option></option>").attr("value", report.id).text(`${report.reportType}: ${report.reportTitle}`));
            });

            data.chatList.forEach(function (chat) {
                $('#ChatID').append($("<option></option>").attr("value", chat.chatSessionID).text(chat.chatSessionName));
            });

        },

        //
        //show/hide chat/report select based on Feedback type
        //
        setupFeedbackTypeChange = function ($popup) {
            var feedbackOption = $($popup).find('#TypeItem');
            var rptSelectDiv = $($popup).find('#rptSelectDiv');
            var chatSelectDiv = $($popup).find('#chatSelectDiv');
            feedbackOption.on('change', function () {
                if ($(this).val() == "ReportsYPTC") {
                    rptSelectDiv.show();
                }
                else {
                    rptSelectDiv.hide();
                }
                if ($(this).val() == "ChatYPTC") {
                    chatSelectDiv.show();
                }
                else {
                    chatSelectDiv.hide();
                }
            });
            return false;
        },


        //
        // setup the change password popup
        //
        setupChangePassword = function() {
            $(document).on('click', '#lnkChangePassword', function() {
                if (!_popup_open) {
                    _popup_open = true;

                    //get the content
                    delta.ajax.get(
                        '/changepassword',
                        function(html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Change Password',
                                content: html,
                                okButtonText: 'Change Password',
                                afterOpen: function() {
                                    _popup_open = false;
                                },
                                okCallback($popup) {
                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/changepassword',
                                        formData,
                                        function(result) {
                                            if (result.isValid) {
                                                delta.popup.close($popup);
                                            } else {
                                                $popup.find('.modal-body').html(result.html);

                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }

                            });
                        }
                    );
                }

                return false;
            });

        },


    dummy = function(){};

    $(document).ready(init);
})();